import styled from 'styled-components';
import { StyleColor } from '../../../utils/styles-constants';

interface LabelProps {
	isActive: boolean;
	isDisabled?: boolean;
}

interface IconProps {
	isActive: boolean;
}

const Label = styled('label')`
	position: relative;
	display: inline-flex;
	padding-left: 25px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 14px;
	line-height: 20px;
	cursor: pointer;

	&:not(:last-of-type) {
		margin-right: 20px;
	}

	&:hover {
		color: ${StyleColor.Black};
	}

	color: ${(props: LabelProps) => props.isActive ? StyleColor.Black : StyleColor.Grey500};

	${(props: LabelProps) => props.isDisabled && `opacity: 0.5;`}

	input {
		display: none;
	}
`;

const Icon = styled('span')`
	box-sizing: border-box;
	position: absolute;
	top: 0;
	left: 0;
	width: 20px;
	height: 20px;
	border: 2px solid currentColor;
	border-radius: 50%;
	color: ${(props: IconProps) => props.isActive ? StyleColor.Blue300 : StyleColor.Grey500};

	${(props: IconProps) => props.isActive && `
		&::before {
			content: '';
			position: absolute;
			top: 4px;
			left: 4px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background-color: currentColor;
		}
	`}
`;

export { Label, Icon };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/RadioBox/styles.ts